import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Routes, Route } from 'react-router-dom';
import SignIn from './SignIn';
import Layout from './Layout';
import Home from './Home';
import DataEntryForm from '../data-entry-form/DataEntryForm';
import Library from '../library';
import Database from '../database';

function AppContent() {
  return (
    <div className="App">
      <AuthenticatedTemplate>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/data-entry-form" element={<DataEntryForm />} />
            <Route path="/library" element={<Library />} />
            <Route path="/database" element={<Database />} />
          </Routes>
        </Layout>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignIn />
      </UnauthenticatedTemplate>
    </div>
  );
}

export default AppContent; 